// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"c7","reportCardBox":"c7","report-img-wrap":"c8","reportImgWrap":"c8","report-title":"c9","reportTitle":"c9","report-date":"c-","reportDate":"c-"};